import {
    LOADING_TOGGLE_ACTION,
    CREATE_JIRA_TICKET_CONFIRMED_ACTION,
    GET_DASHBOARD_FAILED_ACTION
} from '../actions/HomeAction';

const initialState = {
    jiraTicketLink: '',
    errorMessage: '',
    successMessage: '',
    showLoading: false,
};

export const HomeReducer = (state = initialState, action) => {
    switch (action.type) {
        case CREATE_JIRA_TICKET_CONFIRMED_ACTION:
            return {
                ...state,
                jiraTicketLink: action.payload,
                errorMessage: '',
                successMessage: 'Jira succesfully created in JIRA',
                showLoading: false,
            };
            
        case GET_DASHBOARD_FAILED_ACTION:
            return {
                ...state,
                errorMessage: action.payload,
                successMessage: '',
                showLoading: false,
            };

        case LOADING_TOGGLE_ACTION:
            return {
                ...state,
                showLoading: true,
            };
        default:
          return state;
    };
};